import type { Session } from '@supabase/supabase-js';
import { supabase } from '../supabaseClient.ts';

/**
 * Wait for the session that an email-confirm or Google redirect just put in
 * the URL. Do not call getUser() first — without a session it 401s and the
 * client signs out, which also throws away the PKCE verifier needed to finish
 * the Google exchange.
 */
export async function waitForAuthSession(timeoutMs = 10000): Promise<Session | null> {
  const existing = (await supabase.auth.getSession()).data.session;
  if (existing) return existing;

  const code = new URLSearchParams(window.location.search).get('code');
  if (code) {
    const { data, error } = await supabase.auth.exchangeCodeForSession(code);
    if (!error && data.session) return data.session;
  }

  return new Promise((resolve) => {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        data.subscription.unsubscribe();
        resolve(session);
      }
    });
    setTimeout(() => {
      data.subscription.unsubscribe();
      void supabase.auth.getSession().then(({ data: { session } }) => resolve(session));
    }, timeoutMs);
  });
}
